import { render, staticRenderFns } from "./homeProductSlider.vue?vue&type=template&id=9a9c0ba0&scoped=true&"
import script from "./homeProductSlider.vue?vue&type=script&lang=js&"
export * from "./homeProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./homeProductSlider.vue?vue&type=style&index=0&id=9a9c0ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9c0ba0",
  null
  
)

export default component.exports